// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "45d30b670fbd4b457b8f05beb0d2ea3c0a193f53/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};